import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';

export default function loginValidation(data){
  let errors = {};

  if(Validator.isEmpty(data.email)){
    errors.email = 'Please enter a valid email address';
  }
  if(Validator.isEmpty(data.pw)){
    errors.pw = 'Please enter your password';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  }
}



// WEBPACK FOOTER //
// ./src/utils/loginValidation.js